import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import config from "config";

// import dotenv from "dotenv";

// dotenv.config();

export const UPDATE_FILED = "authUpdateField";
export const AUTH_SUCCESS = "authSuccess";
export const AUTH_REST = "authReset";
export const AUTH_INIT = "authINIT";
export const TOGGLE_DARK_MODE = "authToggleDarkMode";
export const TOGGLE_SIDE_BAR = "authToggleSideBar";
export const SET_DASHBOARD_DATA = "authDashboardData";

export const updateFields = ({ prop, value }) => ({
  type: UPDATE_FILED,
  payload: { prop, value },
});

export function setToken(token) {
  if (typeof window !== "undefined") {
    localStorage.setItem("token", token);
  }
}

export function getToken() {
  if (typeof window !== "undefined") {
    return localStorage.getItem("token");
  }
  return null;
}

export function removeToken() {
  if (typeof window !== "undefined") {
    return localStorage.removeItem("token");
  }
  return null;
}

export function getSideBar() {
  if (typeof window !== "undefined") return localStorage.getItem("sidebar");
}

export const useAuth = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  return {
    ...auth,
    getMe,
    getToken,
    submitLogin,
    dispatch,
    logout,
    submitInit,
    submitResetPassword,
    toggleDarkMode,
    toggleSideBar,
    getSideBar,
    handleSuccessMessages,
    getDashboardData,
  };
};
export const axiosInstance = axios.create({
  //baseURL: "http://localhost:8000/api/v1",
  //baseURL: "https://tapi.hashuresport.com/api/v1",
  baseURL: config.API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  //timeout: 5000,
  headers: {
    Authorization: getToken() ? `Bearer ${getToken()}` : "",
    "Accept-Language": "fa",
  },
});
export const submitInit = (data) => async (dispatch) => {
  try {
    const result = await axiosInstance.post("/auth/init", data);
    dispatch({
      type: AUTH_INIT,
      payload: {
        userName: data.user_name,
        // step: result.data.next,
        // remember_token: result.data.remember_token,
      },
    });
  } catch (e) {
    handleErrors(e);
  }
};
export const toggleDarkMode = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: TOGGLE_DARK_MODE,
    });
  } catch (e) {
    handleErrors(e);
  }
};

export const toggleSideBar = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: TOGGLE_SIDE_BAR,
    });
  } catch (e) {
    handleErrors(e);
  }
};

export const submitLogin = (data, cb) => async (dispatch) => {
  try {
    let result = await axiosInstance.post("/login", data);
    result = result.data;
    dispatch({
      type: AUTH_SUCCESS,
      payload: { userMeta: result.data.user },
    });
    setToken(result.data.accessToken);
    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const submitCompelet = (data) => async (dispatch) => {
  try {
    const result = await axiosInstance.post("/auth/complate", data);
    dispatch({
      type: AUTH_SUCCESS,
      payload: { userMeta: result.data.me },
    });
    setToken(result.data.token);
  } catch (e) {
    handleErrors(e);
  }
};
export const submitResetPassword = (data, cb) => async (dispatch) => {
  try {
    const result = await axiosInstance.post("/auth/reset-password", data);

    dispatch({
      type: AUTH_SUCCESS,
      payload: { userMeta: result.data.me },
    });
    setToken(result.data.token);
    cb();
  } catch (e) {
    handleErrors(e);
  }
};
export const getMe = () => async (dispatch) => {
  try {
    let result = await axiosInstance.get("/me");
    result = result.data;

    dispatch({
      type: AUTH_SUCCESS,
      payload: { userMeta: result.data },
    });
  } catch (e) {
    handleErrors(e);
  }
};
export const getDashboardData = (from = null, to = null) => async (
  dispatch
) => {
  try {
    dispatch(updateFields({ prop: "LoadDashboardData", value: true }));
    let url = "/me/dashboard";

    if (from) {
      url = `/me/dashboard?from=${from}`;
    }
    if (to) {
      url = `/me/dashboard?to=${to}`;
    }
    if (to && from) {
      url = `/me/dashboard?from=${from}&to=${to}`;
    }
    const result = await axiosInstance.get(url);
    dispatch({
      type: SET_DASHBOARD_DATA,
      payload: result.data,
    });
    dispatch(updateFields({ prop: "LoadDashboardData", value: false }));
  } catch (e) {
    // handleErrors(e);
    dispatch(updateFields({ prop: "LoadDashboardData", value: false }));
    dispatch({
      type: SET_DASHBOARD_DATA,
      payload: null,
    });
  }
};
export const logout = () => async (dispatch) => {
  try {
    await axiosInstance.post("/auth/logout");
    dispatch({
      type: AUTH_REST,
    });
    removeToken();
  } catch (e) {
    dispatch({
      type: AUTH_REST,
    });
    removeToken();
  }
};

export const resetAuth = () => async (dispatch) => {
  try {
    dispatch({
      type: AUTH_REST,
    });
  } catch (e) {
    handleErrors(e);
  }
};

// 🔧 Helper to show error toast
const showError = (msg) => {
  toast.error(msg, {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

// 🔧 Helper to handle redirect and token remove
const redirectTo = (path = "/") => {
  removeToken();
  window.location.href = path;
};

// 🔧 Main error handler
export const handleErrors = (e) => {
  const res = e?.response;
  const message = res?.data?.message || "";
  const status = res?.status;
  const isTokenExpired = /TokenExpiredError/.test(message);
  const errors = res?.data?.errors;

  // Token Expired
  if (isTokenExpired && status === 401) {
    redirectTo("/auth/login");
    return;
  }

  // Network error (no response)
  if (!res) {
    showError("خطای شبکه، لطفا دوباره تلاش کنید.");
    return;
  }

  // Unauthorized access
  if (status === 401) {
    showError("عدم احراز هویت");
    redirectTo("/");
    return;
  }

  // Validation errors
  if (errors && typeof errors === "object") {
    Object.values(errors)
      .flat()
      .forEach((errMsg) => showError(errMsg));
    return;
  }

  // Fallback for any message
  if (message) {
    showError(message);
  } else {
    showError("خطایی رخ داده است.");
  }
};

export const handleSuccessMessages = (message) => {
  toast.success(message, {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
